import ExercisePage from "../components/ExercisePage";

export default function PaperBankExercisePage() {
  return <ExercisePage isPaperBank={true} />;
}
